import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

const SETUP_CAPACITY_PAGE_CLOSURE_TAB: ConfigurationPageTables = {
  type: ConfigurationPageType.TABLE,
  label: "PROPERTY_CLOSURE",
  path: "closures",
  description: "CONF_PAGE_DESC_DEFAULT",
  model: {
    dynamicPath: true,
    entityName: "hebergement.hebergement_nom_court",
    label: "PROPERTY_CLOSURE",
    path: "/api/closures",
    name: "Closure",
    attributes: [
      {
        key: "hebergement.hebergement_nom_court",
        order: 1,
        label: "PROPERTY",
        visible: true,
      },
      {
        align: "right",
        key: "start_date",
        order: 2,
        label: "DATE_START",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "end_date",
        order: 3,
        label: "DATE_END",
        type: FormatType.DATE,
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        labelKey: "hebergement_nom_court",
        label: "PROPERTY",
        lookup: "hebergement",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/closures/export" },
    import: { path: "/api/closures/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "hebergement",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
      },
      {
        key: "date_range",
        startDateField: "start_date",
        endDateField: "end_date",
        startDateLabel: "DATE_START",
        endDateLabel: "DATE_END",
        type: ConfigurationFormType.DateRangePicker,
      },
    ],
    creatable: true,
    createOptions: [
      {
        key: "hebergement",
        flex: "100%",
        required: true,
      },
      {
        key: "date_range",
        flex: "100%",
        required: true,
      },
    ],
    copyable: false,
    editable: false,
    deletable: true,
  },
};

const SETUP_CAPACITY_PAGE_CAPACITY_TAB: ConfigurationPageTables = {
  type: ConfigurationPageType.TABLE,
  label: "CAPACITY",
  path: "capacities",
  description: "CONF_DESC_SETUP_CAPACITY",
  model: {
    dynamicPath: true,
    entityName: "uh_cat.short_name",
    label: "CAPACITY",
    path: "/api/capacities-grouped",
    name: "Capacity",
    attributes: [
      {
        key: "uh_cat.property.hebergement_nom_court",
        order: 1,
        label: "PROPERTY",
        visible: true,
      },
      {
        key: "uh_cat.short_name",
        order: 2,
        label: "UH_CAT",
        visible: true,
      },
      {
        align: "right",
        key: "start_date",
        order: 3,
        label: "DATE_START",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "end_date",
        order: 4,
        label: "DATE_END",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "capacity",
        order: 5,
        label: "CAPACITY",
        visible: true,
        type: FormatType.NUMBER,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/capacities-grouped/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        labelKey: "hebergement_nom_court",
        label: "PROPERTY",
        lookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "uh_cat",
        labelKey: "short_name",
        label: "UH_CAT",
        lookup: "uh_cat",
        watchLookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/capacities-grouped/export" },
    import: { path: "/api/capacities-grouped/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "uh_cat.property",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
        watchedBy: "uh_cat",
        watchLookup: "uh_cat__property",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
          property: {
            path: "uh_cat.property.id",
          },
        },
        key: "uh_cat",
        label: "UH_CAT",
        labelKey: "short_name",
        watchField: [
          {
            paramsKey: "property",
            paramsValue: "id",
            watchFieldPath: "uh_cat.property",
          },
        ],
      },
      {
        key: "date_range",
        startDateField: "start_date",
        endDateField: "end_date",
        startDateLabel: "DATE_START",
        endDateLabel: "DATE_END",
        type: ConfigurationFormType.DateRangePicker,
      },
      {
        inputType: "integer",
        key: "capacity",
        label: "CAPACITY",
        type: ConfigurationFormType.Input,
      },
    ],
    creatable: true,
    createOptions: [
      {
        key: "uh_cat.property",
        flex: "100%",
        required: true,
      },
      {
        key: "uh_cat",
        flex: "50%",
        required: true,
      },
      {
        key: "capacity",
        flex: "50%",
      },
      {
        key: "date_range",
        flex: "100%",
        required: true,
      },
    ],
    copyable: false,
    editable: true,
    editOptions: [
      {
        key: "uh_cat.property",
        flex: "100%",
        required: true,
      },
      {
        key: "uh_cat",
        flex: "50%",
        required: true,
      },
      {
        key: "capacity",
        flex: "50%",
      },
      {
        key: "date_range",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
  },
};

const SETUP_CAPACITY_PAGE_OUT_OF_ORDER_TAB: ConfigurationPageTables = {
  type: ConfigurationPageType.TABLE,
  label: "OUT_OF_ORDER",
  path: "out-of-orders",
  description: "CONF_PAGE_DESC_DEFAULT",
  model: {
    dynamicPath: true,
    entityName: "uh_cat.short_name",
    label: "OUT_OF_ORDER",
    path: "/api/out-of-orders-grouped",
    name: "Out of order",
    attributes: [
      {
        key: "uh_cat.property.hebergement_nom_court",
        order: 1,
        label: "PROPERTY",
        visible: true,
      },
      {
        key: "uh_cat.short_name",
        order: 2,
        label: "UH_CAT",
        visible: true,
      },
      {
        align: "right",
        key: "start_date",
        order: 3,
        label: "DATE_START",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "end_date",
        order: 4,
        label: "DATE_END",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "out_of_order",
        order: 5,
        label: "OUT_OF_ORDER",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/out-of-orders-grouped/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        labelKey: "hebergement_nom_court",
        label: "PROPERTY",
        lookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "uh_cat",
        labelKey: "short_name",
        label: "UH_CAT",
        lookup: "uh_cat",
        watchLookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/out-of-orders-grouped/export" },
    import: { path: "/api/out-of-orders-grouped/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "uh_cat.property",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
        watchedBy: "uh_cat",
        watchLookup: "uh_cat__property",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
          property: {
            path: "uh_cat.property.id",
          },
        },
        key: "uh_cat",
        label: "UH_CAT",
        labelKey: "short_name",
        watchField: [
          {
            paramsKey: "property",
            paramsValue: "id",
            watchFieldPath: "uh_cat.property",
          },
        ],
      },
      {
        key: "date_range",
        startDateField: "start_date",
        endDateField: "end_date",
        startDateLabel: "DATE_START",
        endDateLabel: "DATE_END",
        type: ConfigurationFormType.DateRangePicker,
      },
      {
        inputType: "number",
        key: "out_of_order",
        label: "OUT_OF_ORDER",
        type: ConfigurationFormType.Input,
      },
    ],
    creatable: true,
    createOptions: [
      {
        key: "uh_cat.property",
        flex: "100%",
        required: true,
      },
      {
        key: "uh_cat",
        flex: "50%",
        required: true,
      },
      {
        key: "out_of_order",
        flex: "50%",
        required: true,
      },
      {
        key: "date_range",
        flex: "100%",
        required: true,
      },
    ],
    copyable: false,
    editable: true,
    editOptions: [
      {
        key: "uh_cat.property",
        flex: "100%",
        required: true,
      },
      {
        key: "uh_cat",
        flex: "50%",
        required: true,
      },
      {
        key: "out_of_order",
        flex: "50%",
        required: true,
      },
      {
        key: "date_range",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
  },
};

export const SETUP_CAPACITY_PAGE = {
  type: ConfigurationPageType.TABS,
  count: 0,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "CAPACITY",
  pageLabel: "CAPACITY_TITLE_SETUP",
  menuLabel: "CAPACITY",
  name: "setup_capacity_grouped",
  path: "capacity",
  tabs: [
    SETUP_CAPACITY_PAGE_CAPACITY_TAB,
    SETUP_CAPACITY_PAGE_OUT_OF_ORDER_TAB,
    SETUP_CAPACITY_PAGE_CLOSURE_TAB,
  ],
};
